import { render, staticRenderFns } from "./multiline_input.vue?vue&type=template&id=1255160f&scoped=true&"
import script from "./multiline_input.vue?vue&type=script&lang=ts&"
export * from "./multiline_input.vue?vue&type=script&lang=ts&"
import style0 from "./multiline_input.vue?vue&type=style&index=0&id=1255160f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1255160f",
  null
  
)

export default component.exports